export default {
    // Specifc refresh events

    REFRESH_PREGAME: 'refreshPregame',
    REFRESH_LIVE: 'refreshLive',

    // Abstracted Events
    UPDATE_ALL: 'updateAll',

    // Heartbeat/Core interaction
    PAUSE_HEARTBEAT: 'pauseHeartbeat',
    STOP_HEARTBEAT: 'stopHeartbeat',
    START_HEARTBEAT: 'startHeartbeat',
    CONFIG_CHANGE: 'configChange',
    UPDATE_TFS: 'updateTfs',
    ACCESS_TOKEN_CHANGE: 'accessTokenChange',
    ACCESS_TOKEN_READY: 'accessTokenReady',
    SWITCH_EXTERNAL: 'switchExternalSource',
    SWITCH_INTERNAL: 'switchInternalSource'
};
